import {Component, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';

import {TranslateService} from '@ngx-translate/core';
import {GlobalMessagesService} from '../../../shared/services/messages/global.messages.service';
import {AddBeneficiaryService} from '../../../shared/services/nso-data-portal/add-services/add-beneficiary-service';
import {debounceTime, share} from 'rxjs/operators';
import * as _ from 'lodash';
import {BeneficiaryData, BeneficiaryDataGetResponse} from '../../../shared/types/nso-data-portal/census-data';
import {BeneficiaryRestService} from '../../../shared/services/nso-data-portal/rest-services/beneficiary-rest.service';
import {ENTRY_STATES} from '../../../shared/types/entry/EntryStatesEnum';
import {ConfirmationService} from 'primeng/api';

@Component({
  selector: 'wsd-beneficiaries',
  templateUrl: './beneficiaries.component.html',
  styleUrls: ['./beneficiaries.component.css']
})
export class BeneficiariesComponent implements OnInit {

  beneficiaries: Observable<BeneficiaryDataGetResponse>;

  filter = {
    name: ''
  };

  searchChanged = new Subject<void>();

  pageSize: number = 10;

  constructor(private addBeneficiaryService: AddBeneficiaryService,
              private message: GlobalMessagesService,
              private confirmService: ConfirmationService,
              private beneficiariesService: BeneficiaryRestService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.searchChanged.pipe(
      debounceTime(500)
    ).subscribe(() => this.loadData(0));
  }

  onPageChange(event) {
    this.loadData(event.first / event.rows);
  }

  private loadData(page: number) {
    this.beneficiaries = this.beneficiariesService.getBeneficiaries(this.pageSize, page, this.filter.name)
      .pipe(share());
  }

  modify(beneficiary: BeneficiaryData) {
    const beneficiaryClone = _.cloneDeep(beneficiary);
    this.addBeneficiaryService.modify(beneficiaryClone);
  }

  confirmDelete(beneficiary: BeneficiaryData) {
    this.confirmService.confirm({
      header: this.translate.instant('DATA_PORTAL.ADMINISTRATION.BENEFICIARIES.CONFIRM_HEADER'),
      message: this.translate.instant('DATA_PORTAL.ADMINISTRATION.BENEFICIARIES.CONFIRM_MESSAGE'),
      accept: () => this.delete(beneficiary)
    });
  }

  private delete(beneficiary: BeneficiaryData) {
    this.beneficiariesService.deleteBeneficiary(beneficiary).subscribe(
      () => {
        this.loadData(0);
        this.message.showSuccessMessage(this.translate.instant('DATA_PORTAL.ADMINISTRATION.BENEFICIARIES.DELETED_MESSAGE'));
      },
      () => this.message.showErrorMessage(this.translate.instant('DATA_PORTAL.ADMINISTRATION.BENEFICIARIES.REMOVAL_ERROR_MESSAGE'))
    );
  }

  create() {
    this.addBeneficiaryService.create();
  }

  search() {
    this.searchChanged.next();
  }

  onSave(event) {
    if (event.$state === ENTRY_STATES.NEW) {
      this.beneficiariesService.createBeneficiary(event).subscribe({
        next: this.handleSuccess.bind(this),
        error: this.handleError.bind(this)
      });
    } else {
      this.beneficiariesService.updateBeneficiary(event).subscribe({
        next: this.handleSuccess.bind(this),
        error: this.handleError.bind(this)
      });
    }
  }

  private handleError() {
    this.message.showErrorMessage(this.translate.instant('DATA_PORTAL.ADMINISTRATION.BENEFICIARIES.SAVE_ERROR_MESSAGE'));
  }

  private handleSuccess() {
    this.loadData(0);
    this.message.showSuccessMessage(this.translate.instant('DATA_PORTAL.ADMINISTRATION.CENSUS.SAVED_MESSAGE'));
  }
}
